import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center border-b-2" }
const _hoisted_2 = { class: "flex-shrink-0 text-sm font-semibold text-gray-700" }
const _hoisted_3 = { class: "flex flex-wrap items-stretch w-full mb-4 relative" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = ["placeholder", "value"]
const _hoisted_7 = { class: "absolute right-0 top-0 bottom-0 flex -mr-px" }
const _hoisted_8 = { class: "unit flex items-center leading-normal rounded rounded-l-none border border-l-0 border-grey-light px-4 whitespace-no-wrap text-sm" }
const _hoisted_9 = { class: "text-red-500 mb-2" }
const _hoisted_10 = { class: "text-red-500 mb-2" }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CalcoloScoresInput',
  props: {
  label: String,
  placeholder: String,
  modelValue: String,
  Number,
  errorMessage: String,
  isInputValid: String,
  unit:String,
  hiddenUnit: Boolean,
},
  setup(__props) {

const props = __props;



let errorMessage = ref(" ");

function validator(evt) {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
    evt.preventDefault();
    errorMessage.value = "Non sono ammessi numeri negativi e lettere. Inserisci un numero positivo.";
  } else {
    errorMessage.value = " ";
    return true;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(__props.label), 1),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("input", _mergeProps({
            class: "w-64 max-w-64 h-10 border border-gray-300 rounded rounded-r-none px-3 leading-normal",
            placeholder: __props.placeholder,
            value: __props.modelValue,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
            onKeypress: validator,
            onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('validateInput')))
          }, _ctx.$attrs, {
            required: "",
            min: "0"
          }), null, 16, _hoisted_6),
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(__props.unit), 1)
          ], 512), [
            [_vShow, !__props.hiddenUnit]
          ])
        ])
      ])
    ]),
    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(errorMessage)), 1),
    _createElementVNode("p", _hoisted_10, _toDisplayString(__props.isInputValid), 1)
  ], 64))
}
}

})